module.exports = __webpack_public_path__ + "static/media/mixing.dc3c0a1e.png";